import * as S from "./PointStandardContent.style";
import { request } from "@/common/api";
import { useQuery } from "@tanstack/react-query";
import { ExerciseInfo } from "@/common/types/healthData";
import { useRecoilValue } from "recoil";
import { studentUserState } from "@/common/states/user";
import { GET_EXERCISE_INFO } from "@/common/querykeys";
import { ReactComponent as ImgPointStandard } from "@/styles/assets/svg/img_point_standard.svg";

interface PointStandardContentProps {
  showMainBox?: boolean;
}

export const PointStandardContent = ({
  showMainBox = true,
}: PointStandardContentProps) => {
  const student = useRecoilValue(studentUserState);

  const { data: exerciseInfo } = useQuery<ExerciseInfo>({
    queryKey: [GET_EXERCISE_INFO],
    queryFn: async () => {
      return await request<ExerciseInfo>({
        method: "GET",
        url: `/exercise/exercise-info/${student.id}`,
      });
    },
  });

  let remainingDays = 0;
  if (exerciseInfo?.diffDays && exerciseInfo?.diffDays !== 0) {
    remainingDays = 84 - exerciseInfo?.diffDays;
  }

  return (
    <S.PointStandardContent>
      {showMainBox && (
        <S.ContentMainBox>
          <S.ContentHeader>
            <S.ContentMainTit>
              <span>
                포인트 지급 종료까지 D-
                {remainingDays > 0 ? remainingDays : <>84</>}
              </span>
              <div>
                <b>최대 50,000포인트 받기 Tip!</b>
              </div>
            </S.ContentMainTit>

            <S.ContentInfoBox>
              <div>
                <span>1</span> 매일 출석 및 추가운동 1회 하기
              </div>
              <div>
                <span>2</span> 나의 운동 프로그램 36회 달성하기
              </div>
            </S.ContentInfoBox>
          </S.ContentHeader>

          <ImgPointStandard height={160} />

          <S.ContentMainTxt>
            획득 포인트는 추후 <b>상품권으로 교환</b>해 드립니다.
          </S.ContentMainTxt>
        </S.ContentMainBox>
      )}

      <S.ContentBox>
        {showMainBox && <S.ContentTit>포인트 획득 방법</S.ContentTit>}

        <S.Content>
          <S.ContentItem>
            <span>매일 지급 포인트</span>
            <S.ItemList $shade={showMainBox}>
              <S.Item>
                하루 한 번 앱 출석
                <span>+ 100P</span>
              </S.Item>
              <S.Item>
                나의 운동 프로그램 1회 참여
                <span>+ 500P</span>
              </S.Item>
              <S.Item>
                <div>
                  신체 건강 또는 부위별 운동 추가 참여
                  <span>(일 최대 1회 지급)</span>
                </div>
                <span>+ 100P</span>
              </S.Item>
            </S.ItemList>
          </S.ContentItem>

          <S.ContentItem>
            <span>보너스 지급 포인트</span>
            <S.ItemList $shade={showMainBox}>
              <S.Item>
                <p>
                  나의 운동 프로그램 누적 참여
                  <br />
                  <b>3회 마다</b> 지급
                </p>
                <span>+ 1,000P</span>
              </S.Item>

              <S.Item>
                <p>
                  나의 운동 프로그램 누적 참여
                  <br />
                  <b>18회, 36회</b> 달성 시 지급
                </p>
                <span>+ 1,600P</span>
              </S.Item>
            </S.ItemList>
          </S.ContentItem>
        </S.Content>
      </S.ContentBox>
    </S.PointStandardContent>
  );
};
